import { compressionErrors } from './compression-errors';
import { uploadIssues } from './upload-issues';

export const troubleshootingArticles = [
  compressionErrors,
  uploadIssues
]; 